export default "__VITE_ASSET__B355Cy1a__"